const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL)
  || 'https://kakobuyfinds.website';

export function getSiteUrl(): string {
  return SITE_URL.replace(/\/+$/, '');
}